import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counters", "studentsList", "form"]

  connect() {
    this.updateCounters()
  }

  markAllPresent() {
    this.element.querySelectorAll('input[type="radio"][value="present"]').forEach((radio) => {
      radio.checked = true
      radio.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  resetAll() {
    this.element.querySelectorAll('input[type="radio"][value="present"]').forEach((radio) => {
      radio.checked = true
      radio.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  updateCounters() {
    const radios = this.element.querySelectorAll('input[type="radio"]:checked')
    let present = 0
    let absent = 0
    let late = 0

    radios.forEach((radio) => {
      switch (radio.value) {
        case "present":
          present++
          break
        case "absent":
          absent++
          break
        case "late":
          late++
          break
      }
    })

    const countersEl = this.element.querySelector('[data-daily-roll-call-target="counters"]')
    if (countersEl) {
      const presentEl = countersEl.querySelector('[data-counter="present"]')
      const absentEl = countersEl.querySelector('[data-counter="absent"]')
      const lateEl = countersEl.querySelector('[data-counter="late"]')

      if (presentEl) presentEl.textContent = present
      if (absentEl) absentEl.textContent = absent
      if (lateEl) lateEl.textContent = late
    }
  }
}
